import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cooki-policy',
  templateUrl: './cooki-policy.component.html',
  styleUrls: ['./cooki-policy.component.css']
})
export class CookiPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
